export const findArrayItemById = (options, selected) => {
  return options.find(
    // eslint-disable-next-line eqeqeq
    (option) => option.id == selected
  )
}
